import script from "./SectionScrollUp.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionScrollUp.vue?vue&type=script&setup=true&lang=js"

import "./SectionScrollUp.vue?vue&type=style&index=0&id=ef6ac27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef6ac27e"]])

export default __exports__